import React from 'react';
import styled from 'styled-components/macro';
import { App } from '../../../app';
import { forMinWidth } from '../../../theme/breakpoints';
import { RootPost, StateTag } from '../../../RootPost';

export interface RouteInfoProps {
    actions: string[];
    ticket: RootPost;
}

export default function RouteInfo(props: RouteInfoProps): JSX.Element {
    const { actions, ticket } = props;

    return <div>
        <Wrapper className="timeline-item">
            <span>
                Routing info (Microsoft Internal)
            </span>
            <span className="light-text">{App.ParseDateTimeToLocal(ticket.createdDate)}</span>
        </Wrapper>
        <RoutesWrapper>
            {actions.map((action, index) => <div key={index}>{action}</div>)}
        </RoutesWrapper>
    </div>
}

const RoutesWrapper = styled.div`
    font-size: 1.4rem;
    padding: 1rem 1.5rem;
`;
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 1rem 0 1.5rem;

    background-color: var(--color-background);

    min-height: var(--timeline-header-min-height);

    >* + * {
        margin-top: .5rem;
        margin-left: 0;
    }

    .light-text {
        color: var(--color-on-background-lighter);
        font-size: 1.6rem;
    }

    ${forMinWidth.md`
        flex-direction: row;
        align-items: center;

        >* + * {
            margin-top: 0;
            margin-left: .5rem;
        }
    `}

    .pill.pill {
        display: inline-block;
        font-size: 1.2rem;
        padding: .4rem .8rem;
        border-radius: .3rem;
        line-height: 100%;
    }
`;
